import { render, staticRenderFns } from "./CategoriasView.vue?vue&type=template&id=23764342&scoped=true&"
import script from "./CategoriasView.vue?vue&type=script&lang=ts&"
export * from "./CategoriasView.vue?vue&type=script&lang=ts&"
import style0 from "./CategoriasView.vue?vue&type=style&index=0&id=23764342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23764342",
  null
  
)

export default component.exports